import React, { useEffect, useState } from 'react';
import { useCurrentlyEditingUserAtom } from '../../atoms/useCurrentlyEditingUserAtom';
import { getAllUsers } from '../../api/authenticateAPIs';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import '../../css/pages/all_users_list.css';
import useAuth from "../../hooks/useAuth";

const UserList = () => {
  const { auth } = useAuth();
  const [, setCurrentlyEditingUser] = useCurrentlyEditingUserAtom();
  const [t, i18n] = useTranslation('global');
  const [userList, setUserList] = useState([]);
  const navigate = useNavigate();
  
  useEffect(() => {
    if (auth.uri === 1) {
      getAllUsers()
        .then((success) => {
          if (success) {
            console.log('success:', success);
            setUserList(success);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      navigate('/Unauthorized');
    }
  }, []);

  const handleUserClick = (id) => {
    console.log(id);
    setCurrentlyEditingUser(userList.find((user) => user.id === id));
    navigate('/EditUser');
  };

  const handleGoBack = () => {
    navigate('/');
};

  return (
    <div className="all-users-list page-wrap">
      <div className="header-title"><h1>{t('userList')}</h1></div>
      <div className="user-detail-wrapper">
        {userList.map((user, key) => {
          return (
            <div key={key} className="user-detail" onClick={() => handleUserClick(user.id)}>
              <div className="user-icon">{user.userFirstname.charAt(0)+user.userLastname.charAt(0)}</div>
              <span className="user-name-label">{user.userFirstname + " " + user.userLastname} </span>
              <span className="user-email-label">{user.userEmail}</span>
            </div>
          );
        })}
      </div>
    <button onClick={handleGoBack} className="return-button">{t('return')}</button>
    </div>
  );
};

export default UserList;
